import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Hero = () => {
  return (
    <div className="video-background">
      <video autoPlay muted loop playsInline>
        <source 
          src="https://assets.mixkit.co/videos/preview/mixkit-golf-player-swinging-5145-large.mp4" 
          type="video/mp4" 
        />
        Your browser does not support the video tag.
      </video>
      <div className="overlay"></div>
      
      <Container className="position-relative h-100 d-flex align-items-center">
        <Row className="w-100">
          <Col lg={8} className="text-white fade-in">
            <h1 className="display-3 fw-bold mb-4">
              Making Golf Accessible. Worldwide.
            </h1>
            <p className="lead mb-4" style={{ fontSize: '1.25rem', opacity: 0.9 }}>
              Discover a place where peace and relaxation will surround you from the moment you step through our doors.
            </p>
            <div className="d-flex gap-3">
              <button className="btn-gold-filled">Explore Services</button>
              <button className="btn-gold">Join the Academy</button>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Hero;